import styled from "styled-components";
import { Skeleton } from "antd";
import "antd/es/skeleton/style/css";

import { Colors } from "../../theme";

export const SkeletonStyled = styled(Skeleton)`
  /* ${({ theme }) => Colors.alpha(theme.primary, 1)}; */
`;
